export const SPOTLIGHT_ONBOARDING_STEP1_TARGET =
	'platform.search-platform.rovo-changeboarding-app-selectors';
export const SPOTLIGHT_MESSAGE_ID = 'plex-filters-changeboarding-rovo-free';
